import moment from "moment";
import { useState } from "react";
import NACell from "../Reusable/DataTable/NACell";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import DataTable from "../Reusable/DataTable";
import { classNames } from "../Reusable/DatePicker/helpers";
import Modal from "../Reusable/Modal";
import TableActionButton from "../Reusable/TableActionButton";
//@ts-ignore
import { OrderDetailPage, Remark, usePDFPrintHook } from "@careinfo/layout";
import { toast } from "react-toastify";
import {
  AccessControl,
  ClientAccessControl,
} from "@careinfo/permission-required";
import OrderActionMenu from "./OrderActionMenu";
import OrderMenu from "./OrderMenu";
import usePostHook from "../../customHooks/usePostHook";
import { queryClient } from "../../router";
import useGetHook from "../../customHooks/useGetHook";
import { ColumnDef } from "@tanstack/react-table";

const OrderList = (props: any) => {
  const [searchParams, setSearchParms] = useSearchParams();
  const { filterParams, setOrdercount, clientType } = props;
  const [receiver, setReceiver] = useState("");
  const {
    register,
    setValue,
    getValues,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm({});

  const [openReviewModal, setOpenReviewModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState("");
  const [openHistoryPopup, setOpenHistoryPopup] = useState(false);
  const [orderActionMenu, setOrderActionMenu] = useState(false);
  const [actionType, setActionType] = useState("");
  const [defaultValue, setDefaultValue] = useState(null);
  const [chargevalue, setChargeValue] = useState();
  const { downloadPrint, isPrintLoading } = usePDFPrintHook();
  const handleLabelPrintDownload = async () => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first");
      return;
    }
    const url = `${APIS.ORDER}order-report/`;
    let formData = {
      order_ids: selectedOrder,
    };
    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDownloadDailyReport = async () => {
    const url = `${APIS.ORDER}order-report/`;
    let formData = {
      filter_data: {
        ...filterParams,
      },
    };
    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.log(err);
    }
  };

  const handleRecevierName = (row: any) => {
    setReceiver(row);
  };

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["order"],
  });

  const { data: profile } = useGetHook({
    queryKey: ["default_branch"],
    url: `${APIS.USER}me/`,
    params: {},
  });

  const handleStatusUpdate = async (
    selectedOrder: any,
    data: any,
    setError: any,
  ) => {
    const url = `${APIS.ORDER}change-status/`;
    let formData = {
      order_ids: selectedOrder,
      status: data?.status,
      remark: data?.remark,
      collected_cod: data?.collected_cod,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setOrderActionMenu(false);
        queryClient.invalidateQueries({
          refetchType: "active",
        });
      }
    } catch (err) {
      toast.success("Somethings went wrong");
    }
  };

  const handleOrderExchange = async (
    selectedOrder: any,
    data: any,
    setError: any,
  ) => {
    const url = `${APIS.ORDER}exchange-order/`;
    let formData = {
      order_ids: selectedOrder,
      cod: data?.cod,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setOrderActionMenu(false);
        queryClient.refetchQueries();
      }
    } catch (err) {
      toast.success("Somethings went wrong");
    }
  };
  const handleBulkComment = async (
    selectedOrder: any,
    data: any,
    setError: any,
  ) => {
    const url = `${APIS.COMMENT}bulk-create/`;
    let formData = {
      branch: profile?.default_branch?.id,
      object_ids: selectedOrder,
      comment: data?.comment,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setOrderActionMenu(false);
        queryClient.refetchQueries();
      }
    } catch (err) {
      toast.success("Somethings went wrong");
    }
  };
  const handleAssignRider = async (
    selectedOrder: any,
    data: any,
    setError: any,
  ) => {
    const url = `${APIS.RUNSHEET}assign-order/`;
    let formData = {
      order_ids: selectedOrder,
      ...data,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setOrderActionMenu(false);
        queryClient.refetchQueries();
      }
    } catch (err) {
      toast.success("Somethings went wrong");
    }
  };

  const handleReverseOrder = async (
    selectedOrder: any,
    data: any,
    setError: any,
  ) => {
    const url = `${APIS.ORDER}rtv-return/`;
    let formData = {
      order_ids: selectedOrder,
      refund_amount: data?.refund_amount,
      delivery_charge: data?.delivery_charge,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setOrderActionMenu(false);
        queryClient.refetchQueries();
      }
    } catch (err) {
      toast.success("Somethings went wrong");
    }
  };

  const handleActionMenu = (data: any, type: string, setError: any) => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder) {
      toast.error("Please select at least one order first");
      setOrderActionMenu(false);
      return;
    }
    if (type === "Change Status") {
      handleStatusUpdate(selectedOrder, data, setError);
    } else if (type === "Exchange") {
      handleOrderExchange(selectedOrder, data, setError);
    } else if (type === "RTV/Return") {
      handleReverseOrder(selectedOrder, data, setError);
    } else if (type === "Bulk Comment") {
      handleBulkComment(selectedOrder, data, setError);
    } else if (type === "Assign To Rider") {
      handleAssignRider(selectedOrder, data, setError);
      // handleBulkComment(selectedOrder, data, setError);
    }
  };

  const handleFilterReset = () => {
    reset();
    setValue("is_rtv", null);
    setValue("order_remarks__isnull", null);
    setValue("is_walking_customer", null);
    setValue("delivery_status__in", null);
    setDefaultValue(null);
  };
  const checkedAllItems = searchParams.get("selectAllItems") === "1";
  const handleIndividualSelect = (value: string) => {
    let selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems || selectedItems === undefined) {
      searchParams.set("selectedItems", value);
      setSearchParms(searchParams);
      return;
    }
    let itemIndex = selectedItems?.findIndex((item) => item === value);
    if (itemIndex > -1) {
      selectedItems.splice(itemIndex, 1);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      if (newSelectedItems.length) {
        searchParams.set("selectedItems", newSelectedItems);
      } else {
        searchParams.delete("selectedItems");
      }
      searchParams.set("selectAllItems", "0");
      setSearchParms(searchParams);
    } else {
      selectedItems?.push(value);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      searchParams.set("selectedItems", newSelectedItems);
      setSearchParms(searchParams);
    }
  };
  const isSelected = (value: string) => {
    const selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems) {
      return false;
    }
    return selectedItems.includes(value);
  };

  const handleSelectAll = (table: any) => {
    const {
      options: { data: tableData },
    } = table;
    const isSelected = searchParams.get("selectAllItems");
    if (isSelected === "1") {
      searchParams.set("selectAllItems", "0");
      searchParams.delete("selectedItems");
      setSearchParms(searchParams);
    } else {
      const selectedItems = tableData
        ?.map((item: any) => item.id)
        .join(",")
        .toString();
      searchParams.set("selectAllItems", "1");
      searchParams.set("selectedItems", selectedItems);
      setSearchParms(searchParams);
    }
  };
  const defaultinternationColumns: any = [
    {
      id: "select",
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className={tw`cursor-pointer`}
          />
        );
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => {
            handleIndividualSelect(row?.original?.id);
            setChargeValue(row?.original?.delivery_charge);
          }}
          className={tw`cursor-pointer`}
        />
      ),
    },
    {
      header: "WayBill",
      accessorKey: "tracking_number",
      cell: ({ row, getValue }: any) => {
        return (
          <button
            // onClick={() => {
            //   appendSelectedItem(row?.original?.id);
            // }}
            className={tw`cursor-pointer focus:outline-none`}
          >
            <p className={tw`whitespace-nowrap`}>{getValue() ?? "N/A"}</p>
            <p className={tw`text-xs text-red-500`}>
              {row?.original?.invoice_print_count ? "Printed" : null}
            </p>
          </button>
        );
      },
    },

    {
      header: "Date",
      accessorKey: "created",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`w-[100px]`}>
              {getValue()
                ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>
          </>
        );
      },
    },
    {
      header: "Forwarding No.",
      accessorKey: "forwarding_no",
      cell: NACell,
    },
    {
      header: "Origin",
      accessorKey: "pickup_branch.name",
      cell: NACell,
    },
    {
      header: "Sender",
      accessorKey: "sender.full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue()}</p>
            <p className={tw`text-[12px]`}>
              {row?.original?.sender?.primary_contact}
            </p>
          </>
        );
      },
    },
    {
      header: "Receiver",
      accessorKey: "receiver.full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue()}</p>
            <p className={tw`text-[12px]`}>
              {row?.original?.receiver?.primary_contact}
            </p>
          </>
        );
      },
    },
    {
      header: "Country",
      accessorFn: (row: any) =>
        row?.receiver?.code || row?.receiver?.country || "N/A",
      cell: ({ getValue }: any) => <p>{getValue()}</p>,
    },
    {
      header: "Piece",
      accessorKey: "total_piece",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Weight",
      accessorKey: "charge_wt",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    // {
    //   header: "Remarks",
    //   accessorKey: "remark",
    //   cell: ({ row, getValue }: any) => (
    //     <button
    //       onClick={() => {
    //         setSelectedOrder(row?.original?.id);
    //         setOpenReviewModal(true);
    //       }}
    //     >
    //       {getValue()} Remarks
    //     </button>
    //   ),
    // },
    {
      header: "Created By",
      accessorKey: "created_by",
      cell: NACell,
    },
    {
      header: "Edited By",
      accessorKey: "updated_by",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`whitespace-nowrap`}>{getValue()}</p>
          </>
        );
      },
    },
    {
      header: "Status",
      accessorKey: "delivery_status.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p
              className={tw`uppercase px-1 text-center rounded-md`}
              style={{ background: row?.original?.delivery_status?.color }}
            >
              {getValue()}
            </p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.rider?.name}
            </p>
          </>
        );
      },
    },
    {
      header: "Shiment Type",
      accessorKey: "package_type.name",
      cell: NACell,
    },
    {
      header: "Service Type",
      accessorKey: "service_type.name",
      cell: NACell,
    },
    {
      header: "Broker",
      accessorKey: "broker.name",
      cell: NACell,
    },

    {
      header: "Hub",
      accessorKey: "hub.name",
      cell: NACell,
    },
    {
      header: "P. Type",
      accessorKey: "reference_type.name",
      cell: NACell,
    },

    // {
    //   header: "Action",
    //   accessorKey: "id",
    //   cell: ({ row, getValue }: any) => (
    //     <AccessControl
    //       children={
    //         <div className={tw` w-full items-center`}>
    //           <div>
    //             <TableActionButton editPath={`edit/${getValue()}`} />
    //           </div>
    //         </div>
    //       }
    //       allowedPermissions={["can_editupdate_consignment"]}
    //     />
    //   ),
    // },
  ];
  const navigate = useNavigate();
  const handleRowClick = (row: any) => {
    window.location.href = `/order?limit=10&page=0#/edit/${row.original.id}`;
  };

  const handleCargoRowClick = (row: any) => {
    window.location.href = `/order#/list/edit/${row.original.id}/`;
  };
  const defaultColumns: any = [
    {
      id: "select",
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className={tw`cursor-pointer`}
          />
        );
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() => {
            handleIndividualSelect(row?.original?.id);
            setChargeValue(row?.original?.delivery_charge);
          }}
          onClick={(e) => e.stopPropagation()}
          className={tw`cursor-pointer`}
        />
      ),
    },
    {
      header: () => <div className={tw`text-center w-full`}>WayBill</div>,
      accessorKey: "tracking_number",
      cell: ({ row, getValue }: any) => {
        return (
          <button
            onClick={() => {
              setSelectedOrder(row?.original?.id);
              setOpenHistoryPopup(true);
            }}
            className={tw`cursor-pointer w-full  focus:outline-none  relative`}
          >
            <ClientAccessControl allowedPermissions={["can_view_order_id"]}>
              <p className={tw`text-xs text-gray-500  whitespace-nowrap`}>
                {row?.original?.order_number}
              </p>
            </ClientAccessControl>
            <ClientAccessControl
              children={
                <p
                  className={classNames(
                    row?.original?.is_duplicate
                      ? tw`text-red-600 text-bold `
                      : "",
                    tw`whitespace-nowrap `,
                  )}
                >
                  {getValue() ?? "N/A"}
                </p>
              }
              allowedPermissions={["can_view_tracking"]}
            />
            <p className={tw`text-xs text-gray-500  whitespace-nowrap`}>
              {moment(row?.original?.created).format("YY-MM-DD HH:mm:ss")}
            </p>
            <ClientAccessControl
              children={
                <p className={tw`text-xs text-gray-500 uppercase `}>
                  {row?.original?.service_type?.name}
                </p>
              }
              allowedPermissions={["can_view_service_type"]}
            />
            {row?.original?.is_pickup_created && (
              <span
                className={tw` absolute -top-2 text-[10px] -right-1 text-white px-[4px] bg-red-400 rounded-full `}
              >
                P
              </span>
            )}
          </button>
        );
      },
    },
    {
      header: "Ref. No.",
      accessorKey: "reference_number",
      cell: ({ getValue }: any) => {
        return (
          <ClientAccessControl
            children={<p> {getValue() || "N/A"} </p>}
            allowedPermissions={["can_view_reference"]}
          />
        );
      },
    },
    {
      header: "Origin",
      accessorKey: "pickup_branch.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.pickup_branch?.warehouse?.name}
            </p>
          </>
        );
      },
    },
    {
      header: "Sender",
      accessorKey: "sender.full_name",
      cell: ({ row }: any) => {
        return (
          <>
            <ClientAccessControl
              children={
                <p className={tw``}>
                  {row?.original?.sender?.full_name ?? "N/A"}{" "}
                </p>
              }
              allowedPermissions={["can_view_sender_name"]}
            />
            <ClientAccessControl
              children={
                <p className={tw`whitespace-nowrap text-sm`}>
                  {row?.original?.sender?.primary_contact ?? "N/A"}{" "}
                </p>
              }
              allowedPermissions={["can_view_sender_number"]}
            />
          </>
        );
      },
    },
    {
      header: "Receiver",
      accessorKey: "receiver.full_name",
      cell: ({ row }: any) => {
        return (
          <>
            <ClientAccessControl
              children={
                <p className={tw``}>
                  {row?.original?.receiver.full_name ?? "N/A"}{" "}
                </p>
              }
              allowedPermissions={["can_view_receiver_name"]}
            />
            <ClientAccessControl
              children={
                <p className={tw`whitespace-nowrap text-sm`}>
                  {row?.original?.receiver.primary_contact ?? "N/A"}{" "}
                </p>
              }
              allowedPermissions={["can_view_receiver_number"]}
            />
            <ClientAccessControl
              children={
                <p className={tw`text-sm`}>
                  {row?.original?.receiver.address ?? "N/A"}{" "}
                </p>
              }
              allowedPermissions={["can_view_receiver_location"]}
            />
          </>
        );
      },
    },
    {
      header: "Destination",
      accessorKey: "destination.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.destination_branch?.warehouse?.name}
            </p>
          </>
        );
      },
    },
    {
      header: "Finance",
      accessorKey: "delivery_charge",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <ClientAccessControl
              children={
                <p className={tw`whitespace-nowrap`}>
                  COD: {row?.original?.cod ?? 0.0}
                </p>
              }
              allowedPermissions={["can_view_cod"]}
            />
            <ClientAccessControl
              children={
                <p className={tw`whitespace-nowrap`}>
                  Collected: {row?.original?.collected_cod ?? 0.0}
                </p>
              }
              allowedPermissions={["can_view_collected"]}
            />
            <ClientAccessControl allowedPermissions={["can_view_d_charge"]}>
              <p className={tw`whitespace-nowrap`}>
                D. Charge:{getValue() ?? 0}
              </p>
            </ClientAccessControl>
          </>
        );
      },
    },
    {
      header: "Weight",
      accessorKey: "weight",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <ClientAccessControl
              children={
                <p>
                  {getValue()}
                  <span className="text-gray-500 text-xs">
                    {" "}
                    {row?.original?.package_type?.unit}
                  </span>{" "}
                </p>
              }
              allowedPermissions={["can_view_weight"]}
            />
          </>
        );
      },
    },
    {
      header: "Pieces",
      accessorKey: "piece",
      cell: ({ getValue }: any) => {
        return (
          <>
            <ClientAccessControl
              children={
                <p>
                  {getValue()}
                  <span className="text-gray-500 text-xs">pieces</span>{" "}
                </p>
              }
              allowedPermissions={["can_view_piece"]}
            />
          </>
        );
      },
    },
    {
      header: "Remarks",
      accessorKey: "remark",
      cell: ({ row, getValue }: any) => (
        <ClientAccessControl
          children={
            <button
              className={tw`focus:outline-none`}
              onClick={() => {
                setSelectedOrder(row?.original?.id);
                setOpenReviewModal(true);

                handleRecevierName(row?.original?.receiver.full_name);
              }}
            >
              {getValue()} Remarks
            </button>
          }
          allowedPermissions={["can_view_remarks"]}
          renderNoAccess={<p>{getValue()} Remarks</p>}
        />
      ),
    },
    {
      header: "Status",
      accessorKey: "delivery_status.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <ClientAccessControl
              children={
                <>
                  <p
                    className={tw`uppercase px-1 text-center rounded-md`}
                    style={{
                      background: row?.original?.delivery_status?.color,
                    }}
                  >
                    {getValue()}
                  </p>
                  <p className={tw`text-xs text-primary `}>
                    {row?.original?.rider?.name}
                  </p>
                </>
              }
              allowedPermissions={["can_view_status"]}
            />
          </>
        );
      },
    },
    // {
    //   header: 'Action',
    //   accessorKey: 'id',
    //   cell: ({ row, getValue }: any) => (
    //     <>
    //       <ClientAccessControl allowedPermissions={['can_view_order_edit']}>
    //         <TableActionButton
    //           editPath={`order?limit=10&page=0#/edit/${getValue()}`}
    //         />
    //       </ClientAccessControl>
    //     </>
    //   ),
    // },
  ];

  return (
    <>
      <DataTable
        url={APIS.ORDER}
        queryKey={"orders"}
        columns={
          clientType?.type === "cargo"
            ? defaultinternationColumns
            : defaultColumns
        }
        tableName={"consignments"}
        setOrdercount={setOrdercount}
        isUpload={true}
        isDownload={true}
        onRowClick={
          clientType?.type === "cargo" ? handleCargoRowClick : handleRowClick
        }
        params={{
          ...filterParams,
          is_rtv: filterParams?.is_rtv ? true : null,
          order_remarks__isnull: filterParams?.order_remarks__isnull
            ? false
            : null,
          is_walking_customer: filterParams?.is_walking_customer ? true : null,
        }}
        actionMenu={
          <>
            <div className="flex items-center justify-end w-full">
              <AccessControl allowedPermissions={["can_perform_action"]}>
                <OrderMenu
                  orderActionMenu={OrderActionMenu}
                  setOrderActionMenu={setOrderActionMenu}
                  setActionType={setActionType}
                />
              </AccessControl>

              {clientType?.type === "cargo" ? (
                <button
                  type="button"
                  className={tw`flex w-full justify-end `}
                  onClick={() => handleDownloadDailyReport()}
                >
                  <span>{isPrintLoading ? "Loading" : "Daliy Report"}</span>
                </button>
              ) : (
                <button
                  type="button"
                  className={tw`flex w-full justify-end `}
                  onClick={() => handleLabelPrintDownload()}
                >
                  <span>{isPrintLoading ? "Loading" : "Order Report"}</span>
                </button>
              )}
            </div>
          </>
        }
      />
      <Modal
        isOpen={openReviewModal}
        setIsOpen={setOpenReviewModal}
        title={"Remark"}
        children={<Remark selectedOrder={selectedOrder} receiver={receiver} />}
      />
      <Modal
        isOpen={orderActionMenu}
        setIsOpen={setOrderActionMenu}
        title={actionType}
      >
        <div className={tw``}>
          <OrderActionMenu
            handleActionMenu={handleActionMenu}
            actionType={actionType}
            isLoading={isPostLoading}
            chargevalue={chargevalue}
          />
        </div>
      </Modal>
      <Modal
        isOpen={openHistoryPopup}
        setIsOpen={setOpenHistoryPopup}
        title={"Order Detail"}
        children={
          <>
            <OrderDetailPage selectedOrder={selectedOrder} />
          </>
        }
      />
    </>
  );
};

export default OrderList;
